"use client";
import { useEffect, useState } from "react";

const COLORS = [
    { hsl: "28 87% 65%", hex: "#F39F5A" }, // 🟠 Orange (your primary)
    { hsl: "220 100% 70%", hex: "#60A5FA" }, // 🔵 Soft Blue
    { hsl: "145 70% 45%", hex: "#22C55E" }, // 🟢 Emerald Green (deeper mint, better contrast)
    { hsl: "280 70% 70%", hex: "#C084FC" }, // 🟣 Lavender
    { hsl: "340 85% 60%", hex: "#FB7185" }, // 🔴 Soft Rose
    { hsl: "200 100% 65%", hex: "#38BDF8" }, // 🔹 Sky Blue
];

function PrimaryThemeSelector() {
    const [currentColor, setCurrentColor] = useState(COLORS[0]);

    const handleColorChange = (color: (typeof COLORS)[0]) => {
        setCurrentColor(color);
        document.documentElement.style.setProperty(
            "--primary-color",
            color.hsl,
        );
        localStorage.setItem("primary-color", color.hsl);
    };

    useEffect(() => {
        // On mount, set default
        const storedColor =
            localStorage.getItem("primary-color") || COLORS[0].hsl;
        const selectedColor =
            COLORS.find((color) => color.hsl === storedColor) || COLORS[0];
        setCurrentColor(selectedColor);
        document.documentElement.style.setProperty(
            "--primary-color",
            selectedColor.hsl,
        );
    }, [currentColor.hsl]);

    return (
        <div className="mx-auto flex gap-2 p-4">
            {COLORS.map((color, index) => (
                <button
                    key={index}
                    onClick={() => handleColorChange(color)}
                    className={`h-6 w-6 rounded-full border-2 ${
                        currentColor.hex === color.hex
                            ? "border-white"
                            : "border-transparent"
                    } transition`}
                    style={{ backgroundColor: color.hex }}
                    aria-label={`Select theme color ${color.hex}`}
                />
            ))}
        </div>
    );
}

export default PrimaryThemeSelector;
